var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgKakaoLogo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_295_327)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.31051 0C4.30838 0 0.253662 3.36159 0.253662 7.51067C0.253662 10.2103 1.97063 12.5764 4.54951 13.9002C4.35969 14.641 3.86375 16.5873 3.76456 17.0035C3.64143 17.5201 3.94412 17.5129 4.14421 17.3748C4.29983 17.2654 6.62561 15.6061 7.62946 14.8904C8.17499 14.9747 8.73591 15.0195 9.31051 15.0195C14.3126 15.0195 18.3674 11.6579 18.3674 7.51067C18.3674 3.36339 14.3126 0 9.31051 0Z",
    fill: "#212121"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_295_327"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.1137,
    height: 17.4537,
    fill: "white",
    transform: "translate(0.253662)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgKakaoLogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/KakaoLogo.5c2cb0ac.svg";
export { ForwardRef as ReactComponent };